module.exports = __webpack_public_path__ + "media/images/products/shop/6-b8d95cb30618aa248081bbfae47e52e1.jpg";